import { NgModule } from '@angular/core';
import { SalesPersonNamePipe } from 'app/pipes/sales-person-name-pipe/sales-person-name.pipe';

@NgModule({
    declarations: [SalesPersonNamePipe],
    providers: [SalesPersonNamePipe],
    exports: [SalesPersonNamePipe],
})
export class SalesPersonNamePipeModule {
}